export function createWoodInventoryFlow({service,isOnline=()=>globalThis.navigator?.onLine!==false}={}){
  if(!service?.create||!service?.update||!service?.get||!service?.archive){
    throw new TypeError('Wood inventory service is required');
  }

  function resultStatus(){
    return isOnline()?'saved_pending_sync':'saved_offline';
  }

  function validationResult(error){
    const message=String(error?.message||'WOOD_INVENTORY_INVALID').slice(0,180);
    let field='wood';
    if(/catalogueKey|customName|Exactly one/i.test(message))field='source';
    else if(/quantityUnit/i.test(message))field='quantityUnit';
    else if(/quantity/i.test(message))field='quantity';
    else if(/notes/i.test(message))field='notes';
    return Object.freeze({
      ok:false,
      status:'validation_error',
      errors:Object.freeze({[field]:message}),
      retryable:false
    });
  }

  async function save(input={}, {id=null}={}){
    try{
      const saved=id?await service.update(id,input):await service.create(input);
      return Object.freeze({
        ok:true,
        status:resultStatus(),
        woodInventoryId:saved.id,
        saved
      });
    }catch(error){
      if(error instanceof TypeError)return validationResult(error);
      return Object.freeze({
        ok:false,
        status:String(error?.message)==='WOOD_INVENTORY_NOT_FOUND'?'not_found':'save_failed',
        errorCode:String(error?.code||error?.message||'WOOD_INVENTORY_SAVE_FAILED').slice(0,80),
        retryable:true
      });
    }
  }

  async function archive(id){
    try{
      const saved=await service.archive(id);
      return Object.freeze({ok:true,status:resultStatus(),woodInventoryId:saved.id,saved});
    }catch(error){
      return Object.freeze({
        ok:false,
        status:'archive_failed',
        errorCode:String(error?.code||error?.message||'WOOD_INVENTORY_ARCHIVE_FAILED').slice(0,80),
        retryable:true
      });
    }
  }

  async function load(id){
    const value=await service.get(id);
    if(!value)throw new TypeError('Wood inventory item not found');
    return value;
  }

  return Object.freeze({save,archive,load});
}
